import { NetworkStatus } from '@apollo/client';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ScreenLoader from '../components/ScreenLoader/ScreenLoader';
import { useUserContext } from '../context/UserContext';

/**
 * PrivateRoute dla React Router v6
 * Komponent ten służy do ochrony tras, które wymagają zalogowanego użytkownika
 */
const PrivateRoute = ({ children }) => {
    const { user, userStatus } = useUserContext();
    const location = useLocation();

    // Pokazanie loadera podczas sprawdzania statusu użytkownika
    if (userStatus === NetworkStatus.loading) {
        return <ScreenLoader fillSpace />;
    }

    // Przekierowanie do strony logowania, jeśli użytkownik nie jest zalogowany
    if (!user) {
        return (
            <Navigate
                to={`/customer/login?referrer=${location.pathname}`}
                replace
            />
        );
    }

    // Jeśli użytkownik jest zalogowany, renderuj przekazane komponenty
    return children;
};

export default PrivateRoute;